import React, { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { GetUserVideo, getVideo } from './../../s3Func/s3Download';
import Amplify, { API, Auth } from 'aws-amplify';
import {CloudfrontVideoFormat} from '../../videos/CloudfrontVideoFormat';
import './Practice.css'
import { useNavigate } from "react-router-dom";
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';
import VideoWebcamRecorder from '../../Unit2/Day4Practice/Recorder';
import rightPuzzle from './Puzzel_Right_HalfCir.svg'
import loading from './../../loading-gif-png-5.gif';

/**
 *  Creates and runs the practice section for Unit3 Module1 
 *  Note: This code is reused in other modules as well
 * @param {*} props 
 * @returns the HTML code for the practice section. 
 */
const EyeContactPractice = (props) => {
    //Initialize variables to be used later
    const dispatch = useDispatch();
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    let [practiceVideo, setPracticeVideo] = useState(false);
    let [practice, setPractice] = useState(false);
    let [practiceCount, setPracticeCount] = useState(0);
    let [displayPracticeVideo, setDisplayPracticeVideo] = useState('')
    let [question, setQuestion] = useState(false);
    let [matchGame, setMatchGame] = useState(false);
    let [matchGame2, setMatchGame2] = useState(false);
    let [introSound, setIntroSound] = useState('');
    let [score, setScore] = useState(0);
    let [firstTime, setFirstTime] = useState(true);
    let [changeText, setChangeText] = useState('_________')
    let [selectImage, setSelectImage] = useState(null)
    let [selectImage1, setSelectImage1] = useState(null)
    

    let [practiceReview, setPracticeReview] = useState(false);
    let [displayCamera, setDisplayCamera] = useState(false);
    let [displayConversation, setDisplayConversation] = useState(false);
    let [displayInfluecer, setDisplayInfluecer] = useState(false);
    let [displayAfterVideo, setDisplayAfterVideo] = useState(false);
    let [displayAudio, setDisplayAudio] = useState(false);
    let [audioReady, setAudioReady] = useState(false);
    let [correctAudio, setCorrectAudio] = useState('')
    let [acceptAudio, setAcceptAudio] = useState('')
    let [tryAgainAudio, setTryAgainAudio] = useState('')
    let [displayAnimal, setDisplayAnimal] = useState(false);
    let [conversation1, setConversation1] = useState(false);
    let [conversation2, setConversation2] = useState(false);
    let [reviewVideo, setReviewVideo] = useState('')
    let [playVideo, setPlayVideo] = useState('')
    let [text, setText] = useState('')
    let [voice, setVoice] = useState('')
    let [questionVideo, setQuestionVideo] = useState('')
    let [animalVoice, setAnimalVoice] = useState('')
    let [animateAnimal, setAnimateAnimal] = useState('')
    let [influencerVideo, setInfluencerVideo] = useState('')
    // Audio refs and trackers for iOS reliability
    const animalAudioRef = useRef(null);
    const expectedAnimalSrcRef = useRef('');
    const uiAudioRef = useRef(null);
    const expectedUiSrcRef = useRef('');
    const uiAudioEndActionRef = useRef(null);
    const [uiVoiceSrc, setUiVoiceSrc] = useState('');
    const [uiShouldPlay, setUiShouldPlay] = useState(false);
    const videoPlayer = {
        minWidth: "100%",
        minHeight: "100%",
        position: "relative",
    };
    const videoPlayer1 = {
        width: '370px',
        height: '655px',
        zIndex: 20,
    };

    // Helper to request playing an animal voice, restarting if same src
    const playAnimalVoice = useCallback(async (src, restartIfSame = true) => {
        const el = animalAudioRef.current;
        const currentSrc = el ? (el.currentSrc || el.src) : '';
        const same = !!currentSrc && currentSrc.includes(src);
        expectedAnimalSrcRef.current = src;
        if (el && same) {
            if (!restartIfSame) return;
            try {
                el.pause();
                el.currentTime = 0;
                await el.play();
            } catch (e) {
                const msg = String(e && e.message ? e.message : e);
                if (!msg.includes('interrupted by a new load request')) {
                    console.log('animal audio replay failed', e);
                }
            }
        } else {
            setAnimalVoice(src);
        }
        setDisplayAnimal(true);
        // Ensure audio is allowed to start even if the image onLoad doesn't fire (same src or cached image)
        setDisplayAudio(true);
    }, []);

    // Helper to play short UI sounds (accept/correct/"I feel ...") with end actions
    const playUiAudio = useCallback(async (src, onEndedAction = null, restartIfSame = true) => {
        const el = uiAudioRef.current;
        const currentSrc = el ? (el.currentSrc || el.src) : '';
        const same = !!currentSrc && currentSrc.includes(src);
        expectedUiSrcRef.current = src;
        uiAudioEndActionRef.current = onEndedAction;
        if (el && same) {
            if (!restartIfSame) return;
            try {
                el.pause();
                el.currentTime = 0;
                await el.play();
            } catch (e) {
                const msg = String(e && e.message ? e.message : e);
                if (!msg.includes('interrupted by a new load request')) {
                    console.log('ui audio replay failed', e);
                }
            }
        } else {
            setUiVoiceSrc(src);
            setUiShouldPlay(true);
        }
    }, []);

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

    let Exit = generateImageUrl('images/Images/close.png')
    let crab_calm = generateImageUrl("images/Module11Images/CharacterScene_Crab_Calm.png")
    let crab_confident = generateImageUrl("images/Module11Images/CharacterScene_Crab_Confident@2x.png")
    let crab_happy = generateImageUrl("images/Module11Images/CharacterScene_Crab_Happy@2x.png")
    let crab_mad = generateImageUrl("images/Module11Images/CharacterScene_Crab_Mad@2x.png")
    let crab_sad = generateImageUrl("images/Module11Images/CharacterScene_Crab_Sad@2x.png")
    let crab_nervous = generateImageUrl("images/Module11Images/CharacterScene_Crab_Nervous@2x.png")
    let greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')

    let [calm, setCalm] = useState('appfiles/feelings/match_calm.jpg');
    let [confident, setConfident] = useState('appfiles/feelings/match_confident.jpg');
    let [happy, setHappy] = useState('appfiles/feelings/match_happy.jpg');
    let [mad, setMad] = useState('appfiles/feelings/match_mad.jpg');
    let [sad, setSad] = useState('appfiles/feelings/match_sad.jpg');
    let [nervous, setNervous] = useState('appfiles/feelings/match_nervous.jpg');
    let [keyword, setKeyword] = useState('')
    let [key1, setKey1] = useState('')
    let [key2, setKey2] = useState('')
    let [key3, setKey3] = useState('')
    let [awesomeJobAudio, setAwesomeJobAudio] = useState('')
    let [conversationAudio, setConversationAudio] = useState('')
    
    const matchPictures = [
        {
            img:calm,
            keyword:'calm'
        },
        {
            img:confident,
            keyword:'confident'
        },
        {
            img:happy,
            keyword:'happy'
        },
        {
            img:mad,
            keyword:'mad'
        },
        {
            img:sad,
            keyword:'sad'
        },
        {
            img:nervous,
            keyword:'nervous'
        }]
    const keywords = ['calm', 'confident', 'happy', 'mad', 'sad', 'nervous']
    const matchCrabs = [crab_calm, crab_confident, crab_happy, crab_mad, crab_sad, crab_nervous]

    let [image1, setImage1] = useState('');
    let [image2, setImage2] = useState('');
    let [image3, setImage3] = useState('');

    let navigate = useNavigate();

    // Generates a random number based on the arraysize passed in
    function getRandomInt(arraysize) {
        return Math.floor(Math.random() * Math.floor(arraysize));
    }

    // Grabs the gif that allows the crab to talk
    const start = async () =>{
        setIntroSound(await getVideo('appfiles/feelings/feelings_practice_select_feeling.mp3', login));
        setConversationAudio(await getVideo("appfiles/greet/greet_practice_watch_conversation.mp3", login));
        setAwesomeJobAudio(await getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login));
        setCorrectAudio(await getVideo('appfiles/feelings/feelings_practice_match_correct.mp3', login));
        setAcceptAudio(await getVideo('media/Module1Videos/button_accept_item.mp3', login));
        setTryAgainAudio(await getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
    }

    useEffect(() => {
        start();
    }, []);

    // When the animal image finishes loading, trigger playback if ready
    useEffect(() => {
        if (!displayAudio) return;
        const el = animalAudioRef.current;
        if (!el || !el.src) return;
        if (!el.paused) return;
        el.currentTime = 0;
        el.play().catch(() => {});
    }, [displayAudio]);

    // Decide which video to play based on the day we're on
    useEffect(() => {
        if(props.unit4){
            setDisplayPracticeVideo(props.reviewVideo)
            setPracticeVideo(true)
        }
        else{
            switch (props.module.currentday) {
                case 1: 
                    setDisplayPracticeVideo(getVideo('appfiles/feelings/practice_video.mp4', login))
                    setPracticeVideo(true)
                    break;
                case 2: 
                    setDisplayPracticeVideo(getVideo('appfiles/feelings/practice_video.mp4', login)) 
                    setPracticeVideo(true)
                    break;
                case 3: 
                    setDisplayPracticeVideo(getVideo('appfiles/feelings/practice_video.mp4', login))
                    setPracticeVideo(true)
                    break;
                default:
                    setPractice(true)
                    setQuestion(true)
                    break;      
            }
        }
    }, []);

    // Set a timer for the specified amount of time ms. 
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const onHit = async (e) => {
        if(firstTime) {
            setScore(score+1);
        }
        setQuestion(false);
        setFirstTime(true);
        e.containerElem.style.visibility = 'hidden';
        setSelectImage1(e.dragData.url)
        if(practiceCount <= 1){
            sleep(3000).then(() => {e.containerElem.style.visibility = ''})
            playUiAudio(correctAudio, () => {
                setIntroSound(getVideo('appfiles/feelings/feelings_practice_match_intro.mp3', login));
                setSelectImage1(null)
                let number = getRandomInt(matchPictures.length);
                setSelectImage(matchCrabs[number]);
                setKeyword(keywords[number])
                let num1 = getRandomInt(matchPictures.length);
                while (number === num1){
                    num1 = getRandomInt(matchPictures.length);
                }
                let num2 = getRandomInt(matchPictures.length);
                while (number === num2 || num1 === num2){
                    num2 = getRandomInt(matchPictures.length);
                }
                let numArray =[number,num1,num2]

                numArray = numArray.map(value => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value);

                setImage1(getVideo(matchPictures[numArray[0]].img, login));
                setKey1(matchPictures[numArray[0]].keyword)

                setImage2(getVideo(matchPictures[numArray[1]].img, login));
                setKey2(matchPictures[numArray[1]].keyword)

                setImage3(getVideo(matchPictures[numArray[2]].img, login));
                setKey3(matchPictures[numArray[2]].keyword)

                setMatchGame(false)
                setMatchGame2(true)
                setQuestion(true)
                setPracticeCount(practiceCount+1)
            })
        }
        else{
            playUiAudio(correctAudio, async () => {
                if(props.unit4){
                  e.containerElem.style.visibility = '';
                  playAnimalVoice(awesomeJobAudio)
                }
                else{
                    switch(props.module.currentday){
                        case 1:
                            (async () => {
                                await GetUserVideo(`influencers/${login.influencerid}/greet_video_message.mp4`).then(data => {
                                    setInfluencerVideo(data)
                                    setQuestionVideo(getVideo("appfiles/greet/greet_greeting_5.mp4", login))
                                    setVoice(getVideo("appfiles/greet/greet_practice_record_5.mp3", login))
                                })
                                setText('Say, "Hi!"')
                            })();
                            setReviewVideo('2709472bcd5220233b1f29701e1c/480.m3u8')
                            e.containerElem.style.visibility = '';
                            setPracticeReview(true)
                            setMatchGame2(false)
                            break
                        case 2:
                            (async () => {
                                await GetUserVideo(`influencers/${login.influencerid}/greet_video_message.mp4`).then(data => {
                                    setInfluencerVideo(data)
                                    setQuestionVideo(getVideo("appfiles/greet/greet_greeting_6.mp4", login))
                                    setVoice(getVideo("appfiles/greet/greet_practice_record_6.mp3", login))
                                })
                                setText("Say, \"Hello\"")
                            })();
                            setReviewVideo('990ed448485ecea60247e822fe30/480.m3u8')
                            e.containerElem.style.visibility = '';
                            setPracticeReview(true)
                            setMatchGame2(false)
                            break
                        case 3:
                            (async () => {
                                await GetUserVideo(`influencers/${login.influencerid}/greet_video_message.mp4`).then(data => {
                                    setInfluencerVideo(data)
                                    setQuestionVideo(getVideo("appfiles/greet/greet_greeting_7.mp4", login))
                                    setVoice(getVideo("appfiles/greet/greet_practice_record_7.mp3", login))
                                })
                                setText("Say, \"Good morning, Mrs. Johnson\"")
                            })();
                            setReviewVideo('2709472bcd5220233b1f29701e1c/480.m3u8')
                            e.containerElem.style.visibility = '';
                            setPracticeReview(true)
                            setMatchGame2(false)
                            break
                        default:
                            e.containerElem.style.visibility = '';
                            setAnimateAnimal(props.awesomeJob)
                            playAnimalVoice(awesomeJobAudio)
                            break
                    }
                }
            })
        }
        
    }

    const onDrop = (e) => {
        setFirstTime(false);
        playUiAudio(tryAgainAudio);
    }

    const afterClick = async (text) => {
        setQuestion(false)
        setChangeText(text)
        let audio = new Audio(await getVideo(`appfiles/feelings/I_feel_${text}.mp3`, login))
        audio.play();
    }

    const updateScore = async () => {
        try {
          await API.post('TIR', '/v3/student/result', {
            body: {
              student_id: login.studentid,
              metric: "practice_feelings",
              result: JSON.stringify({
                day: props.module.currentday,
                created: new Date().toISOString(),
                values: [{ value: score, target: 2 }],
              }),
            },
          });
        } catch (error) {
          console.log(error);
        }
      };

    return (
        <>
            {practiceVideo && <CloudfrontVideoFormat source={displayPracticeVideo} back='/feelings' background={props.background} close={props.setDisplayPractice} ended={() => {
                    setPracticeVideo(false); 
                    setPractice(true); 
                    setQuestion(true) 
            }}/>}
            {practice &&
                <div className='Module11Practice' style={{ backgroundImage: `url(${props.background})`}}> 
                    {question && <audio autoPlay onEnded={() => (setQuestion(false))}> 
                        <source src={introSound}></source>
                    </audio>}
                    <img className='back-btn-ftb' src={Exit} onClick={() => {
                            props.setDisplayPractice(false)
                        }}>
                    </img>
                    <br/>
                    <h2 className='practiceHeader12'>How do you feel today?</h2>
                    {/* <img className='selectCrab' src={selectImage}/> */}

                    <img className='greenCheckPractice12' style={{opacity : selectImage ? 1 : 0, pointerEvents : selectImage ? "auto" : "none"}} src={greenCheck} alt="" onClick={() => { 
                        setQuestion(false);
                        playUiAudio(acceptAudio, () => {
                            setIntroSound(getVideo('appfiles/feelings/feelings_practice_match_intro.mp3', login));
                            setPractice(false);
                            setSelectImage1(null)
                            let number = getRandomInt(matchPictures.length);
                            setSelectImage(matchCrabs[number]);
                            setKeyword(keywords[number])
                            let num1 = getRandomInt(matchPictures.length);
                            while (number === num1){
                                num1 = getRandomInt(matchPictures.length);
                            }
                            let num2 = getRandomInt(matchPictures.length);
                            while (number === num2 || num1 === num2){
                                num2 = getRandomInt(matchPictures.length);
                            }
                            let numArray =[number,num1,num2]

                            numArray = numArray.map(value => ({ value, sort: Math.random() }))
                            .sort((a, b) => a.sort - b.sort)
                            .map(({ value }) => value);

                            setImage1(getVideo(matchPictures[numArray[0]].img, login));
                            setKey1(matchPictures[numArray[0]].keyword)

                            setImage2(getVideo(matchPictures[numArray[1]].img, login));
                            setKey2(matchPictures[numArray[1]].keyword)

                            setImage3(getVideo(matchPictures[numArray[2]].img, login));
                            setKey3(matchPictures[numArray[2]].keyword)
            
                            setMatchGame(true)
                            setMatchGame2(false)
                            setQuestion(true)
                            setPracticeCount(practiceCount+1)
                        })
                    }}/>
                    <br/><br/><br/>
                    <h1 className='practiceText11'>I feel {changeText}.</h1>
                    <div class="grid2">
                        <div class="grid-item" onClick={()=>(setSelectImage(crab_happy), afterClick('happy'))}><img className='crabExpression' src={crab_happy}/><h2 className='practiceHeader11'>Happy</h2></div>
                        <div class="grid-item" onClick={()=>(setSelectImage(crab_confident), afterClick('confident'))}><img className='confidentExpression' src={crab_confident}/><h2 className='practiceHeader11'>Confident</h2></div>
                        <div class="grid-item" onClick={()=>(setSelectImage(crab_mad), afterClick('mad'))}><img className='madExpression' src={crab_mad}/><h2 className='practiceHeader11'>Mad</h2></div>
                        <div class="grid-item" onClick={()=>(setSelectImage(crab_sad), afterClick('sad'))}><img className='sadExpression' src={crab_sad}/><h2 className='practiceHeader11'>Sad</h2></div>
                        <div class="grid-item" onClick={()=>(setSelectImage(crab_nervous), afterClick('nervous'))}><img className='crabExpression' src={crab_nervous}/><h2 className='practiceHeader11'>Nervous</h2></div>
                        <div class="grid-item" onClick={()=>(setSelectImage(crab_calm), afterClick('calm'))}><img className='calmExpression' src={crab_calm}/><h2 className='practiceHeader11'>Calm</h2></div>
                        
                    </div>
            </div>}
            {matchGame &&
                <div className='Module11Practice' style={{ backgroundImage: `url(${props.background})`}}>
                    {question && <audio autoPlay onEnded={() => (setQuestion(false))}> 
                        <source src={introSound}></source>
                    </audio>}
                    <img className='back-btn-ftb' src={Exit} onClick={() => {
                            props.setDisplayPractice(false)
                        }}>
                    </img>
                    <br/>
                    <h2 className='practiceHeader12'>Match Emotions</h2>
                    <DropTarget targetKey={keyword} onHit={(e)=>{onHit(e)}}>
                        <div className='matchBox'>
                            <div className='leftSide'>
                                <div className='selectCrab'>
                                    <img src={selectImage}/>
                                </div>
                                <h2 className='keyword'>{keyword}</h2>
                            </div>
                            {selectImage1&&<div className='rightSide'>
                                <img className='matchImage' src={selectImage1}/>
                            </div>}
                            
                        </div>
                    </DropTarget>
                    <div class="grid11">
                        <div  class="grid-item11">
                            {keyword === key1 ?
                                <DragDropContainer dragData={{url: image1, id: 1}} targetKey={key1}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image1}/></div>
                                </DragDropContainer>
                            :
                                <DragDropContainer dragData={{url: image1, id: 1}} targetKey={key1} onDragEnd={(e)=>{onDrop(e)}}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image1}/></div>
                                </DragDropContainer>
                            }                   
                        </div>
                        <div  class="grid-item11">
                            {keyword === key2 ?
                                <DragDropContainer dragData={{url: image2, id: 2}} targetKey={key2}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image2}/></div>
                                </DragDropContainer>
                            :
                                <DragDropContainer dragData={{url: image2, id: 2}} targetKey={key2} onDragEnd={(e)=>{onDrop(e)}}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image2}/></div>
                                </DragDropContainer>
                            }                   
                        </div>
                        <div  class="grid-item11">
                            {keyword === key3 ?
                                <DragDropContainer dragData={{url: image3, id: 3}} targetKey={key3}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image3}/></div>
                                </DragDropContainer>
                            :
                                <DragDropContainer dragData={{url: image3, id: 3}} targetKey={key3} onDragEnd={(e)=>{onDrop(e)}}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image3}/></div>
                                </DragDropContainer>
                            }                   
                        </div>
                    </div>
            </div>}

            {matchGame2 &&
                <div className='Module11Practice' style={{ backgroundImage: `url(${props.background})`}}>
                    {question && <audio autoPlay onEnded={() => (setQuestion(false))}> 
                        <source src={introSound}></source>
                    </audio>}
                    <img className='back-btn-ftb' src={Exit} onClick={() => {
                            props.setDisplayPractice(false)
                        }}>
                    </img>
                    <br/>
                    <h2 className='practiceHeader12'>Match Emotions</h2>
                    <DropTarget targetKey={keyword} onHit={(e)=>{onHit(e)}}>
                        <div className='matchBox'>
                            <div className='leftSide'>
                                <div className='selectCrab'>
                                    <img src={selectImage}/>
                                </div>
                                <h2 className='keyword'>{keyword}</h2>
                            </div>
                            {selectImage1&&<div className='rightSide'>
                                <img className='matchImage' src={selectImage1}/>
                            </div>}
                        </div>
                    </DropTarget>
                    <div class="grid11">
                        <div  class="grid-item11">
                            {keyword === key1 ?
                                <DragDropContainer dragData={{url: image1, id: 1}} targetKey={key1}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image1}/></div>
                                </DragDropContainer>
                            :
                                <DragDropContainer dragData={{url: image1, id: 1}} targetKey={key1} onDragEnd={(e)=>{onDrop(e)}}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image1}/></div>
                                </DragDropContainer>
                            }                   
                        </div>
                        <div  class="grid-item11">
                            {keyword === key2 ?
                                <DragDropContainer dragData={{url: image2, id: 2}} targetKey={key2}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image2}/></div>
                                </DragDropContainer>
                            :
                                <DragDropContainer dragData={{url: image2, id: 2}} targetKey={key2} onDragEnd={(e)=>{onDrop(e)}}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image2}/></div>
                                </DragDropContainer>
                            }                   
                        </div>
                        <div  class="grid-item11">
                            {keyword === key3 ?
                                <DragDropContainer dragData={{url: image3, id: 3}} targetKey={key3}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image3}/></div>
                                </DragDropContainer>
                            :
                                <DragDropContainer dragData={{url: image3, id: 3}} targetKey={key3} onDragEnd={(e)=>{onDrop(e)}}>
                                    <div style={{backgroundImage: `url(${rightPuzzle})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundPosition: 'center', width: '300px', height: '200px'}}><img className="matchImage" src={image3}/></div>
                                </DragDropContainer>
                            }                   
                        </div>
                    </div>
            </div>}

            {/* Always-mounted UI audio element */}
            <audio
                ref={uiAudioRef}
                src={uiVoiceSrc}
                preload='auto'
                playsInline
                onLoadedData={() => {
                    const el = uiAudioRef.current;
                    if (!el) return;
                    const expected = expectedUiSrcRef.current;
                    const currentSrc = el.currentSrc || el.src;
                    if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
                    if (!uiShouldPlay) return;
                    el.currentTime = 0;
                    el.play().catch((e) => {
                        const msg = String(e && e.message ? e.message : e);
                        if (!msg.includes('interrupted by a new load request')) {
                            console.log('ui audio play failed', e);
                        }
                    });
                }}
                onEnded={() => {
                    const action = uiAudioEndActionRef.current;
                    uiAudioEndActionRef.current = null;
                    setUiShouldPlay(false);
                    if (typeof action === 'function') {
                        action();
                    }
                }}
            />

            {/* Always-mounted animal audio element */}
            <audio
                ref={animalAudioRef}
                src={animalVoice}
                preload='auto'
                playsInline
                onLoadedData={() => {
                    const el = animalAudioRef.current;
                    if (!el) return;
                    // Only play when the animal image has loaded (displayAudio true)
                    if (!displayAudio) return;
                    const expected = expectedAnimalSrcRef.current;
                    const currentSrc = el.currentSrc || el.src;
                    if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
                    el.currentTime = 0;
                    el.play().catch((e) => {
                        const msg = String(e && e.message ? e.message : e);
                        if (!msg.includes('interrupted by a new load request')) {
                            console.log('animal audio play failed', e);
                        }
                    });
                }}
                onPlay={() => { setAudioReady(true); }}
                onEnded={() => {
                    setAudioReady(false)
                    setDisplayAudio(false)
                    setDisplayAnimal(false)
                    if(props.unit4){
                        updateScore()
                        if (props.module.reviewIcon === false){
                            dispatch({type: props.stepComplete ,payload: "practice"});
                        }
                        props.setDisplayPractice(false)

                    }
                    else{
                        if(animateAnimal === props.practiceMessage){
                            setDisplayInfluecer(true)
                        }
                        else if(animateAnimal === props.practiceConversation){
                            setConversation1(true)
                        }
                        else if(animateAnimal === props.awesomeJob){
                            updateScore()
                            props.module.sectionCompleted = props.module.sectionCompleted + 1
                            if (props.module.reviewIcon === false){
                                dispatch({type: props.stepComplete ,payload: "practice"});
                            }
                            props.setDisplayPractice(false)
                        }
                    }
                }}
            />

            {practiceReview && <CloudfrontVideoFormat source={reviewVideo} back='/unit3' background={props.background} close={props.setDisplayPractice} ended={() => {
                    setPracticeReview(false); 
                    setDisplayCamera(true)
            }}/>}

            {displayCamera && !displayAfterVideo && <VideoWebcamRecorder 
                background={props.background} 
                question={questionVideo} 
                outputText={text} 
                name={`feelings_practice_video_${props.module.currentday}.mp4`} 
                setDisplayCelebrateAfterVideo={setDisplayAfterVideo}  
                setDisplayCelebrateRecord={setDisplayCamera} 
                end={() => {
                    setAnimateAnimal(props.practiceMessage)
                    playAnimalVoice(getVideo("appfiles/greet/greet_practice_special_message.mp3", login))
                }} 
                voice={voice} 
                setPlayVideo ={setPlayVideo} 
                close={props.setDisplayPractice}
            />}

            {displayAfterVideo && 
            <div id='recordpage' style={{ backgroundImage: `url(${props.background})`}}>
                    <img className='back-btn-ftb' src={Exit} onClick={() => {
                        props.setDisplayPractice(false)}}>
                    </img> 
                    {displayInfluecer && <div id='influencerVideo'>
                        <video style={videoPlayer} autoPlay onEnded={() => (setDisplayInfluecer(false), setDisplayConversation(true), setAnimateAnimal(props.practiceConversation), 
                                    playAnimalVoice(conversationAudio))} 
                            onError={() => (setDisplayInfluecer(false), setDisplayConversation(true), setAnimateAnimal(props.practiceConversation), 
                                        playAnimalVoice(conversationAudio))} playsInline>
                        <source src={influencerVideo} type="video/mp4"></source>
                        </video>
                    </div>}
                    {conversation1 && <div id='borderVideo'>
                        <video style={videoPlayer1} autoPlay onEnded={() => (setConversation2(true), setConversation1(false))} onError={() => (setConversation2(true), setConversation1(false))} playsInline>
                            <source src={questionVideo} type="video/mp4"></source>
                        </video>
                    </div>}
                    {conversation2 && <div id='border'>
                        <video style={{width: '391px', height: '580px', left: '50%'}} autoPlay onEnded={() => {
                                    setAnimateAnimal(props.awesomeJob)
                                    playAnimalVoice(awesomeJobAudio)
                                    setConversation2(false)
                                }}
                            onError={() => {
                                setAnimateAnimal(props.awesomeJob)
                                playAnimalVoice(awesomeJobAudio)
                                setConversation2(false)
                            }} playsInline>
                            <source src={playVideo} type="video/mp4"></source>
                        </video>
                    </div>}
                    {displayAnimal && <img className="animateCrab" style={(audioReady) ? {} : { display: 'none' }}  onLoad={()=>(setDisplayAudio(true))} src={animateAnimal} />}
                    {displayAnimal && !audioReady && (<img alt='' id='loading' src={loading} />)}
            </div>}


        </>
    )

}
export default EyeContactPractice